export default __webpack_public_path__ + "static/media/shape_bottom.a2aba6cf.svg";